export const blockClicksOnLoad = () => {
    window.onbeforeunload = function () {
        var buttons = document.querySelectorAll('[type="submit"], .button-lock, .ace-cart-actions-btn a');

        [].forEach.call(buttons, function (button) {
            button.classList.add('disabled');
            button.disabled = true;
        });
    };
}